module.exports={"Clear search":"Cancella ricerca"};